export default "__VITE_ASSET__B$XwSJFe__"